import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { PPAVkycComponent } from './components/ppa-vkyc/ppa-vkyc.component';
import { ErrorPageComponent } from './admin/components/error-page/error-page.component';

export const routes: Routes = [
    {
        path: 'reset-password',
        component: ResetPasswordComponent,
    },
    {
        path: 'unlock-user',
        component: ResetPasswordComponent,
    },
    {
        path: 'api-banking-reset-password',
        component: ResetPasswordComponent,
    },
    {
        path: 'dormant-user-reset-password',
        component: ResetPasswordComponent,
    },
    {
        path: 'update-mobile-number',
        component: ResetPasswordComponent,
    },
//*********************before url change code start***************************** */      
    // {
    //     path: 'reset-password/:token',
    //     component: ResetPasswordComponent,
    // },
    // {
    //     path: 'unlock-user/:token',
    //     component: ResetPasswordComponent,
    // },
    // {
    //     path: 'api-banking-reset-password/:token',
    //     component: ResetPasswordComponent,
    // },
    // {
    //     path: 'dormant-user-reset-password/:token',
    //     component: ResetPasswordComponent,
    // },

 //*********************before url change code end***************************** */   
    // {
    //     path: 'update-mobile-number',
    //     component: ResetPasswordComponent,
    // },
    // {
    //     path: 'PPA-vkyc',
    //     component: PPAVkycComponent,
    // },
    // {
    //     path: "user-login",
    //     component: YesbankUserLoginComponent
    // },
    // {
    //     path: "forget",
    //     component: YesbankForgetPasswordComponent,
    // },
    {
        path: '', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)

    },
    {
        path: 'error-page',
        component: ErrorPageComponent,
    },
    {
        path: '**',
        redirectTo: 'error-page',
        pathMatch: 'full'
    }
  

];

export const routing: ModuleWithProviders<any> = RouterModule.forRoot(routes, {
    // preloadingStrategy: PreloadAllModules,  // <- comment this line for activate lazy load
    useHash: true,
    anchorScrolling: 'enabled',
    relativeLinkResolution: 'legacy'
});
